<template>
    <div>
        <textarea v-model="_value" :name="`q_${mode}_${no_plus}`"></textarea>
    </div>
</template>

<script>
export default {
    name: "LongSentence",
    props: ["no", "parentNo", "mode", "type", "value", "isInput", "onChange"],
    computed: {
        _value: {
            get() {
                return !this.value[0] || this.value[0] === "undefined"
                    ? ""
                    : this.value[0];
            },
            set(value) {
                const { no, parentNo, type } = this;
                this.onChange({ no, parentNo, value, type });
            }
        },
        no_plus() {
            return this.no + 1;
        }
    }
};
</script>